<template>
    <div>
        <div class="divider brtd"></div>
        <p class="document" :class="openedClass">
            <a :href="fileLink" target="_blank" v-text="name" @click="markOpened()"></a><br />{{ description }}<br />
            <small>
                <a v-if="!hasBeenRead" @click.prevent="markRead()">Mark as read</a>
                <span v-else>Document has been marked as read</span>
            </small>
        </p>
    </div>
</template>
<script>
    export default {
        props: {
            id: {
                type: Number,
                required: true
            },
            markOpenedLink: {
                type: String,
                required: true
            },
            markReadLink: {
                type: String,
                required: true
            },
            fileLink: {
                type: String,
                required: true
            },
            name: {
                type: String,
                required: true
            },
            description: {
                type: String,
                required: true
            },
            opened: {
                type: Boolean,
                required: true
            },
            read: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                hasBeenOpened: this.opened,
                hasBeenRead: this.read
            };
        },
        computed: {
            openedClass() {
                return {
                    unopened: !this.hasBeenOpened,
                    unread: !this.hasBeenRead
                }
            }
        },
        methods: {
            markOpened() {
                window.axios.post(this.markOpenedLink, { id: this.id })
                    .then(this.openedSuccess)
                    .catch(this.openedFailure);
            },
            openedSuccess(response) {
                this.hasBeenOpened = true;
            },
            openedFailure(error) {
                console.log(error.message);
            },
            markRead() {
                window.axios.post(this.markReadLink, { id: this.id })
                    .then(this.readSuccess)
                    .catch(this.readFailure);
            },
            readSuccess(response) {
                this.hasBeenRead = true;
            },
            readFailure(error) {
                console.log(error.message);
            }
        }
    };
</script>


// WEBPACK FOOTER //
// Document.vue?11013e00